/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardCodeResponse
 */
export interface RewardCodeResponse {
    /**
     * The reward code
     * @type {string}
     * @memberof RewardCodeResponse
     */
    code: string;
    /**
     * The amount of coins rewarded by this code
     * @type {number}
     * @memberof RewardCodeResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the RewardCodeResponse interface.
 */
export function instanceOfRewardCodeResponse(value: object): value is RewardCodeResponse {
    let isInstance = true;
    isInstance = isInstance && "code" in value && value["code"] !== undefined;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;

    return isInstance;
}

export function RewardCodeResponseFromJSON(json: any): RewardCodeResponse {
    return RewardCodeResponseFromJSONTyped(json, false);
}

export function RewardCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardCodeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'amount': json['amount'],
    };
}

export function RewardCodeResponseToJSON(value?: RewardCodeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'amount': value.amount,
    };
}

